import type { FieldDef } from './wizard/fields'
import { emptyDash, formatDate } from '@/lib/utils'

/** The shape `GET /browse/:id` returns. */
export interface DetailRecord {
  id: string
  code: string
  kind: 'experiment' | 'reference'
  title: string
  swatchHex: string | null
  researcherName: string | null
  dyeSource: string | null
  dyeSourceScientific: string | null
  manuscript: string | null
  recipeNumber: string | null
  referenceYear: number | null
  experimentDate: string | null
  placeOfExperiment: string | null
  notes: string | null
  resLabL: number | null
  resLabA: number | null
  resLabB: number | null
  publishedAt: string | null
  projectName: string | null
  sourceProjectId: string | null
  mordants: { id: string; name: string }[]
  photos: { id: string; filename: string; url: string }[]
  linkedRecords: { id: string; code: string; title: string; kind: string }[]
  vocabulary: Record<string, string>
  [field: string]: unknown
}

export const hasValue = (value: unknown) =>
  value !== null && value !== undefined && value !== '' && value !== '—'

/** Vocabulary ids arrive resolved in `record.vocabulary`; everything else is literal. */
export function resolve(field: FieldDef, record: DetailRecord): string | null {
  if (field.name === 'morMordantIds') {
    return record.mordants.map((mordant) => mordant.name).join(', ') || null
  }
  if (field.name === 'dyeSourceIds') return record.dyeSource
  if (field.name === 'manuscriptId') return record.manuscript

  const value = record[field.name]
  if (value === null || value === undefined || value === '') return null

  if (field.vocabulary) return record.vocabulary[value as string] ?? null
  if (field.kind === 'date') return formatDate(String(value))

  return `${emptyDash(value as string)}${field.suffix ? ` ${field.suffix}` : ''}`
}

export function labOf(record: DetailRecord) {
  if (record.resLabL === null || record.resLabA === null || record.resLabB === null) return null
  return { L: record.resLabL, a: record.resLabA, b: record.resLabB }
}
